import { AISpecialty } from "../../shared/types";

function isOfTypeAISpecialty (specialty: string): specialty is AISpecialty {
    const types: AISpecialty[] = ["Dermatology", "Otolaryngology"];
    return types.includes(specialty as AISpecialty);
}

export default isOfTypeAISpecialty
